export default __webpack_public_path__ + "static/media/loogoo.7e108827.png";